import React, { useEffect, useState, useContext } from 'react'
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { Store } from '../../Utils/Store'
import './AdminStyles.css'

const AdminDashboard = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { state, dispatch } = useContext(Store)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Check authentication
    if (!state.Admin) {
      navigate('/admin/login', { 
        state: { from: location },
        replace: true 
      })
      return
    }
    setLoading(false)
  }, [navigate, location, state.Admin])

  const handleLogout = () => {
    dispatch({ type: 'AdminLogout' })
    navigate('/admin/login', { replace: true })
  }

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="admin-text-center">
          <i className="fa fa-spinner fa-spin admin-spinner"></i>
          <p style={{ marginTop: '15px', color: '#666' }}>Loading...</p>
        </div>
      </div>
    )
  }
  
  return (
    <div>
      <Helmet>
        <title>Admin Dashboard - KD General Transport LLC</title>
      </Helmet>
      <div className="admin-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="admin-dashboard-container">
                <h1 className="admin-dashboard-title">Admin Dashboard</h1>
                
                <div className="row">
                  <div className="col-md-3">
                    <div className="admin-sidebar">
                      <h3>Navigation</h3>
                      <ul className="admin-nav-list">
                        <li className="admin-nav-item">
                          <Link 
                            to="/admin/categories" 
                            className={`admin-nav-link ${location.pathname.includes('/categories') ? 'active' : ''}`}
                          >
                            <i className="fa fa-list" style={{ marginRight: '10px' }}></i>
                            Category Management
                          </Link>
                        </li>
                        <li className="admin-nav-item">
                          <Link 
                            to="/admin/data" 
                            className={`admin-nav-link ${location.pathname.includes('/data') ? 'active' : ''}`}
                          >
                            <i className="fa fa-cog" style={{ marginRight: '10px' }}></i>
                            Data Management
                          </Link>
                        </li>
                        <li className="admin-nav-item">
                          <Link 
                            to="/" 
                            className="admin-nav-link"
                          >
                            <i className="fa fa-home" style={{ marginRight: '10px' }}></i>
                            Back to Website
                          </Link>
                        </li>
                        <li className="admin-nav-item">
                          <button
                            onClick={handleLogout}
                            className="admin-nav-button"
                          >
                            <i className="fa fa-sign-out" style={{ marginRight: '10px' }}></i>
                            Logout
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="admin-content">
                      <Outlet />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminDashboard
